import styled, {css} from 'styled-components'
import * as RSwitch from '@radix-ui/react-switch'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

type StyledSwitchSize = 'sm' | 'md'

export const StyledSwitchWrapper = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        white-space: nowrap;
        label {
            color: ${palette.neutral[950]};
            font-weight: 400;
            ${typography.textSm};
        }
    `
)

export const makeSwitchRootSizeStyle = () =>
    ({
        sm: css`
            width: 32px;
            height: 18px;
        `,
        md: css`
            width: 44px;
            height: 24px;
        `
    }) as const satisfies Record<NonNullable<StyledSwitchSize>, ReturnType<typeof css>>

export const StyledSwitchRoot = styled(RSwitch.Root)<{$size: StyledSwitchSize}>(
    ({theme: {palette}, $size}) => css`
        background-color: ${palette.neutral[300]};
        border-radius: 48px;
        position: relative;
        transition: background-color 100ms;
        will-change: background-color;
        cursor: pointer;
        &:disabled {
            cursor: not-allowed;
        }
        &[data-state='checked'] {
            background-color: ${palette.primary[500]};
        }
        ${makeSwitchRootSizeStyle()[$size]}
    `
)

export const makeSwitchThumbSizeStyle = () =>
    ({
        sm: css`
            width: 12px;
            height: 12px;
            &[data-state='checked'] {
                transform: translateX(18px);
            }
        `,
        md: css`
            width: 20px;
            height: 20px;
            &[data-state='checked'] {
                transform: translateX(22px);
            }
        `
    }) as const satisfies Record<NonNullable<StyledSwitchSize>, ReturnType<typeof css>>

export const StyledSwitchThumb = styled(RSwitch.Thumb)<{$size: StyledSwitchSize}>(
    ({$size}) => css`
        display: block;
        width: 20px;
        height: 20px;
        background-color: white;
        border-radius: 100%;
        transition: transform 100ms;
        transform: translateX(2px);
        will-change: transform;
        box-shadow: 0px 1px 3px 0px #1018281a;
        ${makeSwitchThumbSizeStyle()[$size]}
    `
)
